<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12 md8 offset-md2>
        <!-- <div style="position:absolute; top:15px; left:10%;">
          <h1 class="greyy">My Queue</h1>
        </div> -->
        <div class="assign-more-btn">
          <v-btn @click="$router.replace('/freeSamplesNew')"  color='grey' dark large class="my-queue">Assign More</v-btn>
        </div>
      </v-flex>
      <v-flex xs12 md8 offset-md2>
        <v-flex md4 xs12 left>
          <h1 class="mb-3 text-xs-center greyy">Assigned Orders</h1>
          <div class="circle">
            <div justify-center align-center v-if="freeSamplesLoading">
              <v-progress-circular
              indeterminate
              color="primary">
              </v-progress-circular>
            </div>
            <div v-else class="pinkk">
              {{Assigned}}
            </div>
          </div>
        </v-flex>
        <v-flex md4 xs12 left>
          <h1 class="mb-3 text-xs-center greyy">Closed Orders</h1>
          <div class="circle">
            <div justify-center align-center v-if="freeSamplesLoading">
              <v-progress-circular
              indeterminate
              color="primary">
              </v-progress-circular>
            </div>
            <div v-else class="pinkk">
              {{Closed}}
            </div>
          </div>
        </v-flex>
        <v-flex md4 xs12 left>
          <h1 class="mb-3 text-xs-center greyy">Total Closed Orders</h1>
          <div class="circle">
            <div justify-center align-center v-if="freeSamplesLoading">
              <v-progress-circular
              indeterminate
              color="primary">
              </v-progress-circular>
            </div>
            <div v-else>
              {{TotalClosed}}
            </div>
          </div>
        </v-flex>
      </v-flex>
      <v-flex xs12 md8 offset-md2>
        <v-flex xs12 md12 v-if="order && order._id" class="table-responsive">
          <table width="100%" class='text-xs-center greyy'>
            <thead>
              <tr>
                <th width="20%" class='text-xs-left'>Order Code</th>
                <th width="20%" class='text-xs-left'>Name</th>
                <th width="20%">No. Samples</th>
                <th width="20%" class='text-xs-left'>Date</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class='text-xs-left'>{{order.orderCode}}</td>
                <!-- <td class='text-xs-left'></td> -->
                <td class='text-xs-left'>{{order.customerID.firstName}} {{order.customerID.lastName}}</td>
                <td>{{order.freeSamples.length}}</td>
                <td class='text-xs-left'>{{ new Date(order.date).getDate() + "/" + (new Date(order.date).getMonth() + 1) + "/" + new Date(order.date).getFullYear() }}</td>
                <td class='text-xs-left'><v-btn @click="$modal.show('actionModal')"  color='grey' dark large class="my-queue">Action</v-btn></td>
              </tr>
            </tbody>
          </table>
        </v-flex>
        <v-flex xs12 md12 text-xs-center mt-5 left v-else style="width:100%;">
          <div class="greyy no-records" v-if="freeSamplesLoading">
            <div justify-center align-center v-if="freeSamplesLoading">
              <v-progress-circular
              indeterminate
              color="primary">
              </v-progress-circular>
            </div>
          </div>
          <div class="greyy no-records" v-else>Zero Assigned Orders.<br>Go get some!</div>
        </v-flex>
      </v-flex>
      <v-flex xs12 md8 offset-md2 v-if="order && order._id">
        <div style="width: 100%;">
          <v-btn color="grey" class="text-xs-right" dark v-if="tabView === ''" @click="tabView = 'list'">List view</v-btn>
          <v-btn color="grey" class="text-xs-right" dark v-else @click="tabView = ''">Normal view</v-btn>
        </div>
        <v-tabs
          v-model="tab"
          background-color="transparent"
          color="basil"
          grow
        >
          <v-tab
            v-for="(item,  index) in itemTypes"
            :key="index"
          >
            {{ item }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" v-if='tabView === "list"'>
          <v-tab-item
            v-for="(item, index) in itemTypes"
            :key="index"
          >
            <v-card
              color="basil"
              flat
              style="float:left; width:100%;"
            >
              <v-card-text>
                <div v-for="(sample, label, sIndex) in freeSamples" :key="sIndex">
                  <div v-if="label === item">
                    <div v-html="getFabricList(label)"> </div>
                  </div>
                  <!-- <div v-if="sample.fabricID.group.type === item">
                    <div>{{sample.fabricID.name}} - {{sample.colourID.name}}</div>
                  </div> -->
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <v-tabs-items v-model="tab" v-else>
          <v-tab-item
            v-for="(item, index) in itemTypes"
            :key="index"
          >
            <v-card
              color="basil"
              flat
            >
              <v-card-text>
                <div v-for="(sample, label, sIndex) in freeSamples" :key="sIndex">
                  <div v-if="label === item">
                    <div v-html="getFabric(label)"> </div>
                  </div>
                  <!-- <div v-if="sample.fabricID.group.type === item">
                    <div>{{sample.fabricID.name}} - {{sample.colourID.name}}</div>
                  </div> -->
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
      <modal name="actionModal" class="printLableModal">
        <v-layout wrap row text-xs-center>
          <v-flex xs12 sm12>
            <v-tabs
              v-model="tabModal"
              background-color="transparent"
              color="basil"
              grow
            >
              <v-tab> Print Label </v-tab>
              <v-tab> Tracking Reference </v-tab>
              <v-tab> Mark Complete </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabModal">
              <v-tab-item>
                <v-flex xs12 sm12 margin-auto text-sm-center v-if="order && order._id">
                  <h1>Address label</h1>
                  <div id="printMe" style="width:235px; height:110px; border:1px solid; text-align: left; font-size: 18px; padding:5px; margin:0 auto;">
                    <div>{{order.customerID.firstName}} {{order.customerID.lastName}}</div>
                    <div>{{order.customerID.phone}}</div>
                    <div>{{order.customerID.address && order.customerID.address.address ? order.customerID.address.address : ''}}</div>
                    <div>{{order.customerID.address && order.customerID.address.city ? order.customerID.address.city : ''}} {{order.customerID.address && order.customerID.address.state ? order.customerID.address.state : ''}} {{order.customerID.address && order.customerID.address.postcode ? order.customerID.address.postcode : ''}}</div>
                  </div>
                  <div class="mt-4">
                    <v-btn color="grey" dark large class="large-buttons confirm_msg_button cursor-pointer" @click="print()">Print</v-btn>
                    <!-- <v-btn color="grey" dark large class="large-buttons confirm_msg_button cursor-pointer" @click="Completed()">Complete</v-btn> -->
                  </div>
                </v-flex>
              </v-tab-item>
              <v-tab-item>
                <v-flex xs12 sm12 margin-auto text-sm-center v-if="order && order._id">
                  <h1>Tracking Reference</h1>
                  <v-text-field label="Tracking Reference" v-model="order.trackingReference"></v-text-field>
                  <div class="mt-4">
                    <v-btn color="grey" dark large class="large-buttons confirm_msg_button cursor-pointer" @click="saveTrackingReference()">Save</v-btn>
                    <!-- <v-btn color="grey" dark large class="large-buttons confirm_msg_button cursor-pointer" @click="Completed()">Complete</v-btn> -->
                  </div>
                </v-flex>
              </v-tab-item>
              <v-tab-item>
                <v-flex xs12 sm12 margin-auto text-sm-center v-if="order && order._id">
                  <h1>&nbsp;Are you sure to mark the order completed?&nbsp;</h1>
                  <div class="mt-4">
                    <v-btn color="grey" dark large class="large-buttons confirm_msg_button cursor-pointer" @click="Completed()">Mark Completed</v-btn>
                  </div>
                </v-flex>
              </v-tab-item>
            </v-tabs-items>
          </v-flex>
        </v-layout>
      </modal>
    </v-layout>

    <v-snackbar dark top v-model="snackbar" :timeout="3000">
      {{ popupText }}
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import FreeSampleService from '@/services/FreeSampleService'
import OrderService from '@/services/OrderService'
export default {
  name: 'MyQueue',
  data () {
    return {
      tab: null,
      tabModal: null,
      loggedInUser: JSON.parse(atob(localStorage.getItem('user'))),
      order: {},
      freeSamplesLoading: true,
      popupText: null,
      snackbar: false,
      loadingText: 'Loading...',
      Assigned: 0,
      Closed: 0,
      TotalClosed: 0,
      items: [],
      itemTypes: [],
      freeSamples: [],
      tabView: 'list'
    }
  },
  mounted () {
    this.getMyFreeSamples()
  },
  methods: {
    async getMyFreeSamples () {
      this.freeSamplesLoading = true

      const response = await FreeSampleService.getMyPendingFreeSamples(this.loggedInUser._id)

      let order = response.data.freeSample
      this.order = order
      this.Assigned = response.data.MyFreeSampleOrdersCount
      this.Closed = response.data.MyClosedOrdersCount
      this.TotalClosed = response.data.AllClosedOrdersCount
      let freeSamples = response.data.freeSample && response.data.freeSample.freeSamples ? response.data.freeSample.freeSamples : []
      this.items = []
      let itemTypes = []
      for (let index = 0; index < freeSamples.length; index++) {
        const freeSample = freeSamples[index]
        if (!(freeSample.fabricID.group.type in this.items)) {
          this.items[freeSample.fabricID.group.type] = [freeSample]
        } else {
          // If it already exists, append it
          this.items[freeSample.fabricID.group.type].push(freeSample)
        }

        if (!itemTypes.includes(freeSample.fabricID.group.type)) {
          itemTypes.push(freeSample.fabricID.group.type)
        }
      }

      var newItems = []
      for (let index = 0; index < itemTypes.length; index++) {
        var item = itemTypes[index]
        if (!Array.isArray(newItems[item])) {
          newItems[item] = []
        }
        for (let sIndex = 0; sIndex < freeSamples.length; sIndex++) {
          var sample = freeSamples[sIndex]
          if (item === sample.fabricID.group.type) {
            if (!Array.isArray(newItems[item][sample.fabricID.name])) {
              newItems[item][sample.fabricID.name] = []
            }
            newItems[item][sample.fabricID.name].push(sample.colourID.name)
          }
        }
      }
      // console.log(newItems)
      this.freeSamples = Object.assign({}, newItems)
      // console.log(this.freeSamples['Shutter']['PolyChoice'])
      this.itemTypes = itemTypes
      this.freeSamplesLoading = false
      return order
    },
    async Completed () {
      let response = await OrderService.updateOrderStatus(this.order._id, 'Sent to Customer')
      if (response.data.success === true) {
        this.popupText = 'Status Updated to "Sent to Customer"'
        this.snackbar = true
        this.getMyFreeSamples()
      }
    },
    getFabric (label) {
      let html = ''
      let tempArray = []
      for (const prop in this.freeSamples) {
        if (prop === label) {
          for (const prop2 in this.freeSamples[prop]) {
            html += '<div style="padding:10px; font-size: 20px;"><h3 style="border:1px solid #565e6f; color: #ea4d76; padding:5px; text-align: center;" class="mb-2">' + prop2 + '</h3>'
            for (const prop3 in this.freeSamples[prop][prop2]) {
              if (!tempArray.includes(prop + prop2 + this.freeSamples[prop][prop2][prop3])) {
                html += '<div style="border: 1px solid #565e6f; color: #565e6f; padding:5px; margin:0 10px 10px 0; float:left;">' + this.freeSamples[prop][prop2][prop3] + '</div>'
                tempArray.push(prop + prop2 + this.freeSamples[prop][prop2][prop3])
                console.log(this.freeSamples[prop][prop2][prop3])
              }
            }
            html += '<div style="clear:both"></div></div>'
          }
        }
      }
      // console.log(tempArray)
      // console.log(label)
      // console.log(this.freeSamples)
      // console.log(this.freeSamples[label])
      return html
    },
    getFabricList (label) {
      let html = ''
      let tempArray = []
      for (const prop in this.freeSamples) {
        if (prop === label) {
          for (const prop2 in this.freeSamples[prop]) {
            html += '<div style="padding:10px; font-size: 20px;">'
            for (const prop3 in this.freeSamples[prop][prop2]) {
              if (!tempArray.includes(prop + prop2 + this.freeSamples[prop][prop2][prop3])) {
                html += '<div class="list-view-column">' + prop2 + ' ' + this.freeSamples[prop][prop2][prop3] + '</div>'
                tempArray.push(prop + prop2 + this.freeSamples[prop][prop2][prop3])
                console.log(this.freeSamples[prop][prop2][prop3])
              }
            }
            html += '</div>'
          }
        }
      }
      // console.log(tempArray)
      // console.log(label)
      // console.log(this.freeSamples)
      // console.log(this.freeSamples[label])
      return html
    },
    print () {
      // Pass the element id here
      this.$htmlToPaper('printMe')
    },
    async saveTrackingReference () {
      let response = await OrderService.updateSingle(this.order._id, 'trackingReference', this.order.trackingReference)
      if (response.data.success === true) {
        this.popupText = 'Tracking reference updated'
        this.snackbar = true
      }
    }
  }
}
</script>
<style scoped>
th, td {
  padding: 10px;
  font-size: 20px;
}
.circle {
  width: 250px;
  height: 250px;
  border: 5px solid #565e6f;
  margin: 0 auto;
  padding-top: 0;
  text-align: center;
  line-height: 250px;
  border-radius: 50%;
  font-size: 72px;
  font-weight: bold;
  color: #565e6f;
}
.md4 {
  width: 33.33%;
}
.pinkk {
  color: #ea4d76;
}
.greyy {
  color: #565e6f;
}
.assign-btn {
  font-size: 20px;
  font-weight: bold;
}
.no-records{
  font-size: 72px;
  font-style: italic;
  font-weight: bold;
  line-height: 1.1;
  opacity: 0.7;
}
.table-responsive{
  width:100%;
  overflow-x: auto;
}
.assign-more-btn{
  /* position:absolute; top:15px; right:15px; */
  text-align: right;
}
@media screen and (max-width: 661px) {
  .md4 {
    width: 100%;
  }
}
</style>
<style>
a.v-tabs__item {
    background: #ddd;
    border: 1px solid #565e6f;
}
a.v-tabs__item.v-tabs__item--active {
    background: #565e6f;
    color: #fff;
}
.list-view-column{
  width:50%;
  float: left;
}
@media screen and (max-width: 661px) {
  .list-view-column{
    width:100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/freeSamples/MyQueue.vue